import { Navigate } from 'react-router-dom';
import { RoutePaths } from '../../../config/route-paths';

export const OverviewPage = (): JSX.Element => <Navigate replace to={RoutePaths.MACHINE_CLAIM_PAIR} />;
